import { PlusOutlined } from "@ant-design/icons";
import { Divider, Radio, Space, Typography } from "antd";
import React from "react";
import { Link, useParams } from "react-router-dom";
import CalendarIcon from "../../assets/svg/CalendarIcon";
import ListIcon from "../../assets/svg/ListIcon";
import SavedListIcon from "../../assets/svg/SavedListIcon";
import { ExportButton } from "../../component/ExportButton";
import { BLACK_4D, BLUE_DARK } from "../../constant/colors";
import { ViewType } from "../../constant/general";
import { Routes } from "../../constant/routes";
import styled from "styled-components";

const { Text, Title } = Typography;

const AddPatientLink = styled(Link)`
  margin: 0;
  overflow: visible;
  text-transform: none;
  border: 1px solid ${BLUE_DARK};
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  height: 32px;
  line-height: 1.5715;
  padding: 4px 15px;
  position: relative;
  text-align: center;
  touch-action: manipulation;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  white-space: nowrap;
  outline: 0;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  text-shadow: 0 -1px 0 #0000001f;
  box-sizing: border-box;
  background: ${BLUE_DARK};
  color: #fff;
  text-decoration: none;

  .anticon {
    margin-right: 8px;
  }

  &:hover {
    opacity: 0.9;
    color: white;
  }
`;

const ToolBar = ({ t, user, onViewTypeChange, viewType, padding = 0 }) => {
  const { filterListId } = useParams();
  const { savedListViewType } = useParams();
  return (
    <div style={{ display: "flex", flexDirection: "column", padding: padding }}>
      {!filterListId && (
        <Title level={4} style={{ color: BLUE_DARK, paddingBottom: 6 }}>
          {t("main_title")}
        </Title>
      )}

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Space>
          <Radio.Group
            onChange={onViewTypeChange}
            value={viewType === ViewType.SavedList.key && filterListId ? savedListViewType : viewType}
            optionType="button"
            buttonStyle="solid"
            style={{ display: "contents" }}
          >
            <Space id="list_view">
              <Radio.Button
                id="list_view"
                value={ViewType.List.key}
                style={{ border: `1px solid #2F549B`, borderRight: "none", borderRadius: "2px" }}
              >
                <Space>
                  <ListIcon
                    active={(viewType === ViewType.SavedList.key ? savedListViewType : viewType) === ViewType.List.key}
                  />
                  {ViewType.List.value(t)}
                </Space>
              </Radio.Button>
            </Space>
            <Space id="calendar_view">
              <Radio.Button id="calendar_view" value={ViewType.Calendar.key} style={{ border: `1px solid #2F549B` }}>
                <Space>
                  <CalendarIcon
                    active={
                      (viewType === ViewType.SavedList.key ? savedListViewType : viewType) === ViewType.Calendar.key
                    }
                  />
                  {ViewType.Calendar.value(t)}
                </Space>
              </Radio.Button>
            </Space>

            {!filterListId && (
              <>
                <Divider
                  type="vertical"
                  style={{ height: "32px", marginRight: "5px", marginLeft: "16px", borderColor: `${BLACK_4D}` }}
                />
                <Space id="filter_list_view" style={{ marginLeft: "13px" }}>
                  <Radio.Button value={ViewType.SavedList.key} style={{ border: `1px solid #2F549B` }}>
                    <Space>
                      <SavedListIcon active={viewType === ViewType.SavedList.key} />
                      {ViewType.SavedList.value(t)}
                    </Space>
                  </Radio.Button>
                </Space>
              </>
            )}
          </Radio.Group>
        </Space>
        <Space>
          <Space>{user && viewType === ViewType.List.key && !filterListId && <ExportButton />}</Space>
          {viewType !== ViewType.SavedList.key && !filterListId && (
            <AddPatientLink
              id="pharmacy_add_patient"
              data-tm-id="add-patient-btn"
              to={Routes.ROOT + Routes.NEW_PATIENT}
            >
              <PlusOutlined style={{ fontSize: 12 }} />
              <Text style={{ color: "white" }}>{t("new_drug_order")}</Text>
            </AddPatientLink>
          )}
        </Space>
      </div>
    </div>
  );
};

export { ToolBar };
